import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AdminManagement from '@views/Admin/Management';

const messages = defineMessages({
  title: {
    id: 'admin.policies.title',
    defaultMessage: 'Manage Policies',
  },
});

function AdminPoliciesPage() {
  const { formatMessage } = useIntl();

  return (
    <AdminManagement.Layout title={formatMessage(messages.title)}>
      <AdminManagement.Policies.List />
    </AdminManagement.Layout>
  );
}

export default AdminPoliciesPage;
